import { render, staticRenderFns } from "./PivotClientReport.vue?vue&type=template&id=cf5b2d0e&scoped=true"
import script from "./PivotClientReport.vue?vue&type=script&lang=js"
export * from "./PivotClientReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5b2d0e",
  null
  
)

export default component.exports